import { InjectionToken } from "@angular/core";
import { IListStateService } from "../interfaces/list-state-service";
import { IListDataService } from "../interfaces/list-data-service";

/**
 * Injection token for the list state service.
 * Used to provide and inject implementations of IListStateService.
 */
export const LIST_STATE_SERVICE = new InjectionToken<IListStateService>("LIST_STATE_SERVICE");

/**
 * Injection token for the list data service.
 * Used to provide and inject implementations of IListDataService.
 */
export const LIST_DATA_SERVICE = new InjectionToken<IListDataService>("LIST_DATA_SERVICE");
